<p-card class="p-card container" [class.proposal-section--valid]="isCompleted && form.valid">
  @if (isDev && !isReadonly) {
    <p-button label="Simulate & copy code" class="btn--simulate" (onClick)="simulateIdDocument()"></p-button>
  }

  <h3 i18n>Validation de l'identité</h3>
  <p i18n>Veuillez saisir une méthode d'identification afin de valider l'identité du client.</p>

  <form class="layout__inner-card" [formGroup]="form">
    <div class="layout--row layout--gap">
      <div class="layout--full-width">
        <label class="label-top" i18n>Méthode d'identification</label>
        <p-dropdown
          [formControl]="form.controls.type"
          [styleClass]="form.controls.type.invalid && form.controls.type.touched ? 'error--input' : ''"
          i18n-placeholder
          placeholder="Choisir"
          optionLabel="name"
          optionValue="value"
          [options]="documentTypesOptions | emTranslate"></p-dropdown>
      </div>

      <div class="layout--full-width">
        <label class="label-top" i18n>Numéro d'identification</label>
        <input
          [formControl]="form.controls.code"
          [ngClass]="{
            'error--input': form.controls.code.invalid && form.controls.code.touched,
          }"
          pInputText
          i18n-placeholder
          placeholder="Inscrire le numéro d'identification"
      /></div>
    </div>
  </form>
</p-card>
